import styles from './control-switch.module.scss';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function ControlSwitch(props) {
  const { title, description, onChange, name, checked, children, error = false } = props;

  const ToolSwitch = styled((switchProps) => (
    <Switch
      data-testid={`ControlSwitch-${name}`}
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...switchProps}
    />
  ))(({ theme }) => ({
    width: 48,
    height: 24,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(22px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#3A3E43',
          opacity: 1,
          border: 0,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
      transform: 'translateY(-1px)',
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: '#DDDFE1',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));

  return (
    <div
      data-testid={`ToolSwitch-${name}`}
      className={`${styles.control_switch} ${error ? styles.control_switch_error : null}`}>
      <div className={styles.control_switch__title_container}>
        <h3 className={styles.control_switch__title}>{title}</h3>
        <FormControlLabel
          className={styles.control_switcher}
          onChange={(e, value) => onChange(e, value)}
          control={<ToolSwitch name={name} sx={{ m: 0 }} checked={checked} />}
        />
      </div>
      <p className={styles.control_switch__description}>{description}</p>
      {children}
    </div>
  );
}
